<div class="" *ngIf="visible" (click)="closeModalWindow()" [ngClass]="isCalendar?'page1':'page'">
  <div class="modal" cdkDrag  cdkDragRootElement=".cdk-overlay-pane"  (click)="$event.stopPropagation();" [ngStyle]="{'min-width': width+'px', 'width': width+'px'}">
    <div class="modal_header"  cdkDragHandle>
      <div class="modal_header_title">{{title}}</div>
      <div class="modal_header_close" (click)="closeModalWindow()">&#10005;</div>
    </div>
    <div class="modal_body" [ngClass]="scrollbar ? 'absolute' : 'static'" [ngStyle]="bodyStyles">
      <div class="modal_body_content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
